var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lottery-item-wrapper"},[_c('div',{staticClass:"prize-name"},[_c('div',[_vm._v(_vm._s(_vm.prizeName[0]))]),(_vm.prizeName[1])?_c('div',[_vm._v(_vm._s(_vm.prizeName[1]))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }